import React, { Fragment, useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
  Card,
  Checkbox,
  Stack,
  Grid,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormLabel,
  TextField,
  Tabs,
  Tab,
  IconButton,
  Autocomplete,
} from "@mui/material";
import Dropdown from "@/components/Dropdown/Dropdown";
import { selectLifecycle } from "../../../features/homepage/homeSlice";
import { selectWorkflow } from "@/features/homepage/workflowManagerSessionSlice";
import { useDispatch, useSelector } from "react-redux";
import axios from "@/features/axiosHelper";
import {
  selectConnectionProfile,
  selectGlobalProfile,
  fetchConnectionProfile,
  fetchGlobalProfile,
  updateOption,
  fetchConnectionPairs,
  selectConnectionPairDetails,
  selectedConnectionPairs,
  setSelectedConnectionPairs,
} from "@/features/settings/settingsSlice";
import { Close as CloseIcon } from "@mui/icons-material";
import "../../ConnectionsBar/ConnectionsBar.css";
import "./WorkflowSettingsPopup.css";
import WorkflowSchedulerSettings from "./WorkflowSchedulerSettings";
import WorkflowScriptSettings from "./WorkflowScriptSettings";
import ShepGridWarning from "@/components/GenericComponents/ShepGridWarning";
import {
  ShepTab,
  ShepTabs,
  ShepCheckbox,
} from "@/components/GenericComponents/ShepComponents";
import { createAlert } from "@/features/homepage/alertSliceList";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function MainTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const CatalogGridCard = ({ optionSchema, profileOption, isGlobal }) => {
  const dispatch = useDispatch();
  const applyNewCatalogValue = (catalogId, value) => {
    let optionValue = JSON.parse(profileOption.Value);
    let entry = { id: catalogId, value: value };
    let ref = optionValue.findIndex((x) => x.id === catalogId);
    if (ref > -1) optionValue[ref] = entry;
    else optionValue.push(entry);
    profileOption.Value = JSON.stringify(optionValue);
  };

  if (profileOption.Value == null) profileOption.Value = "[]";

  return (
    <Stack
      direction={"column"}
      justifyContent={"space-between"}
      style={{ minHeight: "50px" }}
    >
      <FormLabel className="conn-pair-options">
        {optionSchema.OptionName}
      </FormLabel>
      {profileOption.CatalogRecordList &&
        profileOption.CatalogRecordList.map((record, k) => {
          let optionValue = JSON.parse(profileOption.Value);
          let catalogValue = optionValue.find((x) => x.id === record.Id);
          if (catalogValue == null) catalogValue = { id: 0, value: -1 };

          return (
            <Stack
              key={k}
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              style={{ minHeight: "50px" }}
            >
              <FormLabel>{record.Code}</FormLabel>
              <RadioGroup
                value={catalogValue.value}
                onChange={(event) => {
                  applyNewCatalogValue(record.Id, event.target.value);
                  dispatch(
                    updateOption({
                      option: profileOption,
                      isGlobal: isGlobal,
                    })
                  );
                }}
              >
                <Stack direction={"row"} style={{ marginLeft: "8px" }}>
                  {Object.keys(optionSchema.ValueList).map((value, l) => (
                    <FormControlLabel
                      key={l}
                      value={value}
                      control={<Radio />}
                      label={optionSchema.ValueList[value]}
                    />
                  ))}
                </Stack>
              </RadioGroup>
            </Stack>
          );
        })}
    </Stack>
  );
};

const ConfigurableFeatureCard = ({
  feature,
  isGlobal,
  onClose,
  workflowName,
}) => {
  const dispatch = useDispatch();
  const selectedOperationId = useSelector(selectWorkflow);
  let connectionProfile = useSelector(selectConnectionProfile);
  let globalProfile = useSelector(selectGlobalProfile);

  const OptionType = {
    Radio: 1,
    NumericInput: 3,
    Catalog: 5,
    Catalog_Grid: 6,
    TimeSpan_Minutes: 7,
    PercentageInput: 8,
  };

  const getOptionFromProfile = (optionId) => {
    let profileValue = connectionProfile.Options.find(
      (x) => x.OptionId === optionId
    );
    if (profileValue == null) return null;

    return JSON.parse(JSON.stringify(profileValue)); //deepcopy since state is readonly
  };
  const getOptionFromGlobal = (optionId) => {
    let globalValue = globalProfile.Options.find(
      (x) => x.OptionId === optionId
    );
    if (globalValue == null) return null;
    return JSON.parse(JSON.stringify(globalValue)); //deepcopy since state is readonly
  };

  const saveConfigOptions = (optionIds, isGlobal) => {
    let options = [];
    let url;
    if (!isGlobal) {
      optionIds.forEach((optionId) => {
        options.push(
          connectionProfile.Options.find((x) => x.OptionId === optionId)
        );
      });
    } else {
      optionIds.forEach((optionId) => {
        options.push(
          globalProfile.Options.find((x) => x.OptionId === optionId)
        );
      });
    }

    axios
      .put(
        `/operations/connection-profiles/${selectedOperationId}/option`,
        {
          ConnectionProfileOptions: options,
        },
        {
          params: {
            operationId: selectedOperationId,
            connectionPairId: connectionProfile?.ConnectionPairId ?? -1,
            isGlobal: isGlobal,
          },
        }
      )
      .then((response) => {
        if (response.error !== undefined && response.error !== null) {
          console.error("Error saving option:", response.error.message);
          dispatch(
            createAlert({
              status: "Error",
              alertType: "single",
              message:
                "Unable to save settings. Error: " + response.error.message,
            })
          );
        } else {
          dispatch(
            createAlert({
              status: "Success",
              alertType: "single",
              message: "Settings saved successfully",
            })
          );
        }
      })

    // heap.io

    const eventProps = {};

    eventProps["Settings - Scope"] = isGlobal
      ? "Default"
      : "Connection-specific";
    eventProps["Settings - Workflow"] = workflowName;
    eventProps["Settings - Subgroup"] = feature.FunctionName;

    window.heap.track("Workflow Settings - Save Settings", eventProps);
  };

  return (
    <Stack direction={"column"}>
      <>
        <SettingsCard
          title={feature.FunctionName}
          description={feature.FunctionDescription}
          className="config-options-card"
        >
          {feature.OperationOptions.map((option, j) => {
            let profileOption = null;
            if (isGlobal) profileOption = getOptionFromGlobal(option.OptionId);
            else profileOption = getOptionFromProfile(option.OptionId);

            let globalOption = getOptionFromGlobal(option.OptionId);

            if (profileOption == null) return;

            let disableNotGlobal = !isGlobal && profileOption.UseGlobal;

            return (
              <Fragment key={j}>
                {option.OptionInputType === OptionType.Radio &&
                  Object.keys(option.ValueList).length <= 3 && (
                    <>
                      <Stack
                        direction={"column"}
                        justifyContent={"space-between"}
                        alignItems={"baseline"}
                        style={{ minHeight: "50px", marginTop: "30px" }}
                      >
                        <FormLabel className="conn-pair-options">
                          {option.OptionName}
                        </FormLabel>
                        {option.OptionDescription && (
                          <FormLabel className="conn-pair-optionDescriptions">
                            {option.OptionDescription}
                          </FormLabel>
                        )}
                        <RadioGroup
                          value={profileOption.Value}
                          onChange={(event) => {
                            profileOption.Value = event.target.value;
                            dispatch(
                              updateOption({
                                option: profileOption,
                                isGlobal: isGlobal,
                              })
                            );
                          }}
                        >
                          <Stack
                            direction={"column"}
                            style={{ marginLeft: "8px" }}
                          >
                            {Object.keys(option.ValueList).map((value, k) => (
                              <FormControlLabel
                                disabled={disableNotGlobal}
                                key={k}
                                value={value}
                                control={<Radio />}
                                label={option.ValueList[value]}
                              />
                            ))}
                          </Stack>
                        </RadioGroup>
                      </Stack>

                      {!isGlobal ? (
                        <Stack
                          key={j}
                          direction={"row"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          style={{ minHeight: "50px", marginBottom: "30px" }}
                        >
                          <FormLabel className="global-option">
                            <Typography>
                              {"Global " +
                                option.OptionName +
                                " is configured as "}
                            </Typography>
                            <Typography>
                              <strong>
                                {option.ValueList
                                  ? option.ValueList[globalOption?.Value]
                                  : globalOption?.Value}
                              </strong>
                            </Typography>
                          </FormLabel>
                          <FormControlLabel
                            control={
                              <ShepCheckbox
                                checked={profileOption.UseGlobal}
                                onChange={() => {
                                  profileOption.UseGlobal =
                                    !profileOption.UseGlobal;
                                  dispatch(
                                    updateOption({ option: profileOption })
                                  );
                                }}
                              />
                            }
                            label="Use Global Setting"
                            style={{ marginLeft: 5, minWidth: 180 }}
                          />
                        </Stack>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                {option.OptionInputType === OptionType.Radio &&
                  Object.keys(option.ValueList).length > 3 && (
                    <>
                      <FormControl
                        sx={{
                          "&:hover.MuiFormControl-root .workflow-settings-radio":
                          {
                            color: "rgba(0, 0, 0, 0.87)",
                          },
                          "&:hover.MuiFormControl-root .conn-pair-options": {
                            color: "#000000",
                          },
                        }}
                      >
                        <FormLabel
                          className="conn-pair-options"
                          style={{ marginBottom: "12px", color: "#000000" }}
                        >
                          {option.OptionName}
                        </FormLabel>
                        <RadioGroup
                          className="workflow-settings-radio"
                          value={profileOption.Value}
                          onChange={(event) => {
                            profileOption.Value = event.target.value;
                            dispatch(
                              updateOption({
                                option: profileOption,
                                isGlobal: isGlobal,
                              })
                            );
                          }}
                        >
                          <Grid container columns={2}>
                            {Object.keys(option.ValueList).map((value, k) => (
                              <Grid item xs={1} key={k}>
                                <FormControlLabel
                                  disabled={disableNotGlobal}
                                  value={value}
                                  control={<Radio />}
                                  label={option.ValueList[value]}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </RadioGroup>
                      </FormControl>

                      {!isGlobal ? (
                        <Stack
                          key={j}
                          direction={"row"}
                          justifyContent={"space-between"}
                          alignItems={"center"}
                          style={{ minHeight: "50px", marginBottom: "30px" }}
                        >
                          <FormLabel className="global-option">
                            <Typography>
                              {"Global " +
                                option.OptionName +
                                " is configured as "}
                            </Typography>
                            <Typography>
                              <strong>
                                {option.ValueList
                                  ? option.ValueList[globalOption?.Value]
                                  : globalOption?.Value}
                              </strong>
                            </Typography>
                          </FormLabel>
                          <FormControlLabel
                            control={
                              <ShepCheckbox
                                checked={profileOption.UseGlobal}
                                onChange={() => {
                                  profileOption.UseGlobal =
                                    !profileOption.UseGlobal;
                                  dispatch(
                                    updateOption({ option: profileOption })
                                  );
                                }}
                              />
                            }
                            label="Use Global Setting"
                            style={{ marginLeft: 5, minWidth: 180 }}
                          />
                        </Stack>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                {option.OptionInputType === OptionType.NumericInput && (
                  <>
                    <FormControl>
                      <Stack
                        direction={"column"}
                        alignItems={"baseline"}
                        justifyContent={"space-between"}
                        style={{ marginTop: "30px" }}
                      >
                        <FormLabel
                          className="conn-pair-options"
                          style={{ marginRight: "8px" }}
                        >
                          {option.OptionName}
                        </FormLabel>
                        <TextField
                          disabled={disableNotGlobal}
                          value={profileOption.Value}
                          onChange={(event) => {
                            profileOption.Value = event.target.value;
                            dispatch(
                              updateOption({
                                option: profileOption,
                                isGlobal: isGlobal,
                              })
                            );
                          }}
                        />
                      </Stack>
                    </FormControl>

                    {!isGlobal ? (
                      <Stack
                        key={j}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        style={{ minHeight: "50px", marginBottom: "30px" }}
                      >
                        <FormLabel className="global-option">
                          <Typography>
                            {"Global " +
                              option.OptionName +
                              " is configured as "}
                          </Typography>
                          <Typography>
                            <strong>
                              {option.ValueList
                                ? option.ValueList[globalOption?.Value]
                                : globalOption?.Value}
                            </strong>
                          </Typography>
                        </FormLabel>
                        <FormControlLabel
                          control={
                            <ShepCheckbox
                              checked={profileOption.UseGlobal}
                              onChange={() => {
                                profileOption.UseGlobal =
                                  !profileOption.UseGlobal;
                                dispatch(
                                  updateOption({ option: profileOption })
                                );
                              }}
                            />
                          }
                          label="Use Global Setting"
                          style={{ marginLeft: 5, minWidth: 180 }}
                        />
                      </Stack>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {option.OptionInputType === OptionType.Catalog && !isGlobal && (
                  <>
                    <Stack
                      direction={"column"}
                      justifyContent={"space-between"}
                      alignItems={"baseline"}
                      style={{ minHeight: "50px" }}
                    >
                      <FormLabel className="conn-pair-options">
                        {option.OptionName}
                      </FormLabel>
                      {profileOption.CatalogRecordList && (
                        <Dropdown
                          width={300}
                          label=""
                          onChange={(event) => {
                            profileOption.Value = event.target.value;
                            dispatch(
                              updateOption({
                                option: profileOption,
                                isGlobal: isGlobal,
                              })
                            );
                          }}
                          value={profileOption.Value}
                          options={profileOption.CatalogRecordList.map((x) => {
                            return {
                              key: x.Id,
                              label: x.Code + " | " + x.Name,
                            };
                          })}
                        ></Dropdown>
                      )}
                    </Stack>

                    <Stack
                      key={j}
                      direction={"row"}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      style={{ minHeight: "50px", marginBottom: "30px" }}
                    >
                      <FormLabel>
                        {
                          "No Global Settings. Option must be set per Connection Pair."
                        }
                      </FormLabel>
                      <FormControlLabel
                        control={
                          <ShepCheckbox checked={false} disabled={true} />
                        }
                        label="Use Global Setting"
                        style={{ marginLeft: 5, minWidth: 180 }}
                      />
                    </Stack>
                  </>
                )}
                {option.OptionInputType === OptionType.Catalog_Grid &&
                  !isGlobal && (
                    <>
                      <CatalogGridCard
                        optionSchema={option}
                        profileOption={profileOption}
                        isGlobal={isGlobal}
                      />

                      <Stack
                        key={j}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        style={{ minHeight: "50px", marginBottom: "30px" }}
                      >
                        <FormLabel>
                          {
                            "No Global Settings. Option must be set per Connection Pair."
                          }
                        </FormLabel>
                        <FormControlLabel
                          control={
                            <ShepCheckbox checked={false} disabled={true} />
                          }
                          label="Use Global Setting"
                          style={{ marginLeft: 5, minWidth: 180 }}
                        />
                      </Stack>
                    </>
                  )}
                {(option.OptionInputType === OptionType.Catalog ||
                  option.OptionInputType === OptionType.Catalog_Grid) &&
                  isGlobal && (
                    <Stack
                      key={j}
                      direction={"column"}
                      justifyContent={"space-between"}
                      alignItems={"baseline"}
                      style={{ minHeight: "50px" }}
                    >
                      <FormLabel>
                        {
                          "No Global Settings. Option must be set per Connection Pair."
                        }
                      </FormLabel>
                    </Stack>
                  )}
                {option.OptionInputType === OptionType.TimeSpan_Minutes && (
                  <>
                    <FormControl>
                      <Stack
                        direction={"column"}
                        alignItems={"baseline"}
                        justifyContent={"space-between"}
                        style={{ marginTop: "30px" }}
                      >
                        <FormLabel
                          className="conn-pair-options"
                          style={{ marginRight: "8px" }}
                        >
                          {option.OptionName}
                        </FormLabel>
                        <TimeSpanPicker
                          disabled={disableNotGlobal}
                          value={profileOption.Value}
                          onChange={(newValue) => {
                            profileOption.Value = JSON.stringify(newValue);
                            dispatch(
                              updateOption({
                                option: profileOption,
                                isGlobal: isGlobal,
                              })
                            );
                          }}
                        />
                      </Stack>
                    </FormControl>

                    {!isGlobal ? (
                      <Stack
                        key={j}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        style={{ minHeight: "50px", marginBottom: "30px" }}
                      >
                        <FormLabel className="global-option">
                          <Typography>
                            {"Global " +
                              option.OptionName +
                              " is configured as "}
                          </Typography>
                          <Typography>
                            <strong>
                              {option.ValueList
                                ? TimeSpanGlobalText(
                                  option.ValueList[globalOption?.Value]
                                )
                                : TimeSpanGlobalText(globalOption?.Value)}
                            </strong>
                          </Typography>
                        </FormLabel>
                        <FormControlLabel
                          control={
                            <ShepCheckbox
                              checked={profileOption.UseGlobal}
                              onChange={() => {
                                profileOption.UseGlobal =
                                  !profileOption.UseGlobal;
                                dispatch(
                                  updateOption({ option: profileOption })
                                );
                              }}
                            />
                          }
                          label="Use Global Setting"
                          style={{ marginLeft: 5, minWidth: 180 }}
                        />
                      </Stack>
                    ) : (
                      ""
                    )}
                  </>
                )}
                {option.OptionInputType === OptionType.PercentageInput && (
                  <>
                    <FormControl>
                      <Stack
                        direction={"column"}
                        alignItems={"baseline"}
                        justifyContent={"space-between"}
                        style={{ marginTop: "30px" }}
                      >
                        <FormLabel
                          className="conn-pair-options"
                          style={{ marginRight: "8px" }}
                        >
                          {option.OptionName}
                        </FormLabel>
                        <Stack direction={"row"} alignItems={"center"} spacing={1}>
                          <TextField
                            disabled={disableNotGlobal}
                            value={profileOption.Value}
                            type="number"
                            inputProps={{ min: 0 }}
                            sx={{ width: 100 }}
                            onChange={(event) => {
                              const val = event.target.value;
                              if (val === "" || parseFloat(val) >= 0) {
                                profileOption.Value = val;
                                dispatch(
                                  updateOption({
                                    option: profileOption,
                                    isGlobal: isGlobal,
                                  })
                                );
                              }
                            }}
                          />
                          <Typography variant="body1" sx={{ fontWeight: "bold" }}>%</Typography>
                        </Stack>
                      </Stack>
                    </FormControl>

                    {!isGlobal ? (
                      <Stack
                        key={j}
                        direction={"row"}
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        style={{ minHeight: "50px", marginBottom: "30px" }}
                      >
                        <FormLabel className="global-option">
                          <Typography>
                            {"Global " +
                              option.OptionName +
                              " is configured as "}
                          </Typography>
                          <Typography>
                            <strong>
                              {globalOption?.Value + "%"}
                            </strong>
                          </Typography>
                        </FormLabel>
                        <FormControlLabel
                          control={
                            <ShepCheckbox
                              checked={profileOption.UseGlobal}
                              onChange={() => {
                                profileOption.UseGlobal =
                                  !profileOption.UseGlobal;
                                dispatch(
                                  updateOption({ option: profileOption })
                                );
                              }}
                            />
                          }
                          label="Use Global Setting"
                          style={{ marginLeft: 5, minWidth: 180 }}
                        />
                      </Stack>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </Fragment>
            );
          })}
        </SettingsCard>
      </>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row-reverse",
          marginTop: "20px",
        }}
      >
        <Button
          className="btn-primary"
          onClick={() => {
            let optionIds = [];
            feature.OperationOptions.map((option) => {
              optionIds.push(option.OptionId);
            });
            saveConfigOptions(optionIds, isGlobal);
          }}
        >
          Save
        </Button>
        <Button
          variant="outlined"
          size="large"
          sx={{
            borderColor: "var(--primary-main)",
            color: "var(--primary-main)",
            p: "20px",
            marginRight: "10px",
            borderRadius: "10px",
          }}
          onClick={onClose}
        >
          Close
        </Button>
      </Box>
    </Stack>
  );
};

export const SettingsCard = ({
  title,
  description,
  style,
  onSave,
  children,
}) => {
  return (
    <Card>
      <Box>{children}</Box>
      {onSave && (
        <Stack direction={"row-reverse"}>
          <Button
            className="btn-primary"
            style={{ width: 180 }}
            onClick={onSave}
          >
            Save
          </Button>
        </Stack>
      )}
    </Card>
  );
};

const ConfigurableFeatureSection = ({
  configurableFeatures,
  selectedOperationId,
  onClose,
  workflowName, // Used for heap.io
}) => {
  const [tabValue, setTabValue] = useState(0);
  const [mainTab, setMainTab] = useState(1);
  const dispatch = useDispatch();
  const [showConnPairList, setShowConnPairList] = useState(true);
  const connPairDetails = useSelector(selectConnectionPairDetails);
  const selectedConnPair = useSelector(selectedConnectionPairs);

  useEffect(() => {
    if (selectedConnPair[0]?.ConnectionPairId > 0) {
      setMainTab(0); //if not already on this tab, open this tab (selected prior to pop up opened)
      setShowConnPairList(false);
      dispatch(
        fetchConnectionProfile({
          operationId: selectedOperationId,
          connectionPairId: selectedConnPair[0]?.ConnectionPairId,
        })
      );
    }
  }, [selectedConnPair]); // SHEP-138: on connection pair change, load connection profile

  useEffect(() => {
    if (connPairDetails === undefined || connPairDetails.length === 0) {
      dispatch(fetchConnectionPairs());
    }
    //dispatch(fetchConnectionPairs());

    dispatch(
      fetchGlobalProfile({
        operationId: selectedOperationId,
      })
    );
  }, []); // SHEP-138: On load get global profile and connection pair details

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleMainTabChange = (event, newValue) => {
    if (newValue === 1) {
      setTabValue(0);
    }
    setMainTab(newValue);

    // heap.io
    switch (newValue) {
      case 0:
        window.heap.track("Workflow Settings - Select Connection Pair Tab");
        break;
      case 1:
        window.heap.track("Workflow Settings - Select Default Tab");
        break;
    }
  };

  // const handleChangeConnectionPair = (event) => {
  //   const pairInfo = connPairDetails.filter(
  //     (row) => row.connectionPairId === event.target.value
  //   );
  //   dispatch(setSelectedConnectionPairs({ selectedConnectionPairs: pairInfo }));
  // };

  const handleAutocompleteSelect = (e, value) => {
    let pairInfo = [value];
    dispatch(setSelectedConnectionPairs({ selectedConnectionPairs: pairInfo }));
  };

  //Returns only connection pairs that have a profile for the selected workflow which is the cue
  //to know they are enabled.
  const enabledConnectionPairsForSelectedWorkflow = connPairDetails.filter(
    (connectionPair) =>
      Array.isArray(connectionPair.ConnectionProfiles) &&
      connectionPair.ConnectionProfiles.some(
        (profile) => profile.OperationId === selectedOperationId
      )
  );

  return (
    <>
      <div>
        <Box sx={{ borderBottom: 1, borderColor: "var(--primary-main)" }}>
          <ShepTabs
            variant="primary"
            value={mainTab}
            onChange={handleMainTabChange}
            sx={{
              "& .MuiTab-root": {
                marginTop: "20px",
              },
            }}
          >
            <ShepTab variant="primary" label={"Connection Pair"}></ShepTab>
            <ShepTab variant="primary" label={"Default"}></ShepTab>
          </ShepTabs>
        </Box>
        <MainTabPanel value={mainTab} index={0}>
          <Autocomplete
            sx={{
              ".MuiInputBase-input": { height: "0px" },
              marginTop: "20px",
            }}
            id="checkboxes-tags-demo"
            options={enabledConnectionPairsForSelectedWorkflow}
            getOptionLabel={(option) => option.ConnectionPairName}
            isOptionEqualToValue={(option, value) => option?.id === value.id}
            renderOption={(props, option) => {
              const { key, ...optionProps } = props;
              return (
                <li className="test" key={key} {...optionProps}>
                  {option.ConnectionPairName}
                </li>
              );
            }}
            style={{ width: 400 }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Connection Pair"
                placeholder="Select Connection Pair"
              />
            )}
            onChange={handleAutocompleteSelect}
            value={selectedConnPair[0] || null}
          // PaperComponent={({ children, ...others }) => (
          //   // <CustomPaperComponent
          //   //   {...paperProps}
          //   //   customFilterString={""}
          //   //   //onClickAway={closeOptionsList}
          //   //   onInputChange={handleCustomFilterChange}
          //   // />
          //   <CustomPaperComponent
          //     children={children}
          //     method={handleCustomFilterChange}
          //   />
          // )}
          />

          {showConnPairList || !(selectedConnPair[0]?.ConnectionPairId > 0) ? (
            <ShepGridWarning title="Select a Connection Pair" />
          ) : (
            <div>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="workflow settings tabs"
                variant="scrollable"
                scrollButtons="auto"
                style={{
                  backgroundColor: "#ffffff",
                  margin: "20px 0",
                  border: "2px solid #edeff2",
                  borderRadius: "15px 15px 0 0",
                }}
                sx={{
                  "button.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected":
                  {
                    color: "var(--primary-main)",
                    fontWeight: "bold",
                  },
                  "span.MuiTabs-indicator": {
                    backgroundColor: "var(--primary-main)",
                  },
                }}
              >
                <Tab label="Workflow Scheduler" />
                {configurableFeatures.map((feature, i) => (
                  <Tab
                    label={feature.FunctionName}
                    key={feature.OperationalFunctionId}
                  />
                ))}
                <Tab label="Scripts" />
              </Tabs>
              <TabPanel value={tabValue} index={0}>
                <WorkflowSchedulerSettings
                  isGlobal={false}
                  onClose={onClose}
                  workflowName={workflowName}
                />
              </TabPanel>
              {configurableFeatures.map((feature, index) => (
                <TabPanel
                  key={feature.OperationalFunctionId}
                  value={tabValue}
                  index={index + 1}
                >
                  <ConfigurableFeatureCard
                    feature={feature}
                    isGlobal={false}
                    onClose={onClose}
                    workflowName={workflowName}
                  />
                </TabPanel>
              ))}
              <TabPanel value={tabValue} index={1 + configurableFeatures.length}>
                <WorkflowScriptSettings
                  isGlobal={false}
                  onClose={onClose}
                  workflowName={workflowName}
                />
              </TabPanel>
            </div>
          )}
        </MainTabPanel>
        <MainTabPanel value={mainTab} index={1}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="workflow settings tabs"
            variant="scrollable"
            scrollButtons="auto"
            style={{
              backgroundColor: "#ffffff",
              margin: "20px 0",
              border: "2px solid #edeff2",
              borderRadius: "15px 15px 0 0",
            }}
            sx={{
              "button.MuiButtonBase-root.MuiTab-root.MuiTab-textColorPrimary.Mui-selected":
              {
                color: "var(--primary-main)",
                fontWeight: "bold",
              },
              "span.MuiTabs-indicator": {
                backgroundColor: "var(--primary-main)",
              },
            }}
          >
            <Tab label="Workflow Scheduler" />
            {configurableFeatures
              .filter((x) => x?.OperationalFunctionId > 5)
              .map((feature, i) => (
                <Tab
                  label={feature.FunctionName}
                  key={feature.OperationalFunctionId}
                />
              ))}
            <Tab label="Scripts" />
          </Tabs>
          <TabPanel value={tabValue} index={0}>
            <WorkflowSchedulerSettings
              isGlobal={true}
              onClose={onClose}
              workflowName={workflowName}
            />
          </TabPanel>
          {configurableFeatures
            .filter((x) => x?.OperationalFunctionId > 5)
            .map((feature, index) => (
              <TabPanel
                key={feature.OperationalFunctionId}
                value={tabValue}
                index={index + 1}
              >
                <ConfigurableFeatureCard
                  feature={feature}
                  isGlobal={true}
                  onClose={onClose}
                  workflowName={workflowName}
                />
              </TabPanel>
            ))}
          <TabPanel value={tabValue} index={1 + configurableFeatures
            .filter((x) => x?.OperationalFunctionId > 5).length} >
            <WorkflowScriptSettings
              isGlobal={true}
              onClose={onClose}
              workflowName={workflowName}
            />
          </TabPanel>
        </MainTabPanel>
      </div>
    </>
  );
};

const WorkflowSettingsPopup = ({ open, onClose }) => {
  const selectedOperationId = useSelector(selectWorkflow);
  const selectedLifecycle = useSelector(selectLifecycle);
  const [operationsSchema, setOperationsSchema] = useState({
    ConfigurableFeatures: [],
    OperationName: "",
  });
  const selectedConnPair = useSelector(selectedConnectionPairs);

  const loadOperationsSchema = () => {
    axios
      .get("/operations/schema", {
        params: {
          cycleId: selectedLifecycle,
          operationId: selectedOperationId,
        },
      })
      .then((response) => {
        setOperationsSchema({
          ConfigurableFeatures: response?.data?.ConfigurableFeatures,
          OperationName: response?.data?.OperationName ?? "",
        });
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    loadOperationsSchema(); // SHEP-138: On init, load operation schema
  }, []);

  return (
    <>
      <Dialog
        className="workflow-settings-container"
        open={open}
        onClose={onClose}
        maxWidth="xl"
        fullWidth={true}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        sx={{ zIndex: "1500" }}
      >
        <DialogTitle
          className="workflow-settings-heading"
          style={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "var(--primary-main)",
            color: "var(--default-light)",
            fontSize: "24px",
            borderRadius: "15px 15px 0 0",
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ fontWeight: "var(--font-semi-bold)" }}>
              Workflow Settings -&nbsp;
            </div>
            <div>
              {" "}
              {selectedConnPair[0]?.ConnectionPairName ? (
                <>{selectedConnPair[0]?.ConnectionPairName + " - "}</>
              ) : (
                ""
              )}{" "}
              {operationsSchema.OperationName}
            </div>
          </div>
          <IconButton
            className="closeIconButton"
            style={{ color: "var(--default-light)" }}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="dialogContent">
          <div>
            <ConfigurableFeatureSection
              configurableFeatures={operationsSchema.ConfigurableFeatures}
              selectedOperationId={selectedOperationId}
              onClose={onClose}
              workflowName={operationsSchema.OperationName}
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default WorkflowSettingsPopup;

const TimeSpanPicker = ({ disabled, value, onChange }) => {
  const [totalMins, setTotalMins] = useState(value ?? 0);

  const SetPositive = (val) => {
    if (val >= 0) return val;
    return 0;
  };

  const OnMinuteChange = (e) => {
    const newMins =
      e.target.value === "" ? 0 : SetPositive(parseInt(e.target.value));
    const oldMins = GetSectionOfTime(totalMins, "minute");
    const newTotalMins = totalMins - oldMins + (newMins ?? 0) * 1;
    setTotalMins(newTotalMins);
    onChange(newTotalMins);
  };
  const OnHourChange = (e) => {
    const newHours =
      e.target.value === "" ? 0 : SetPositive(parseInt(e.target.value));
    const oldHours = GetSectionOfTime(totalMins, "hour");
    const newTotalMins = totalMins - oldHours * 60 + (newHours ?? 0) * 60;
    setTotalMins(newTotalMins);
    onChange(newTotalMins);
  };
  const OnDayChange = (e) => {
    const newDays =
      e.target.value === "" ? 0 : SetPositive(parseInt(e.target.value));
    const oldDays = GetSectionOfTime(totalMins, "day");
    const newTotalMins =
      totalMins - oldDays * 24 * 60 + (newDays ?? 0) * (24 * 60);
    setTotalMins(newTotalMins);
    onChange(newTotalMins);
  };
  return (
    <>
      <Box>
        <TextField
          className="TimeSpan"
          disabled={disabled}
          label="Days"
          type="number"
          value={GetSectionOfTime(totalMins, "day")}
          onChange={OnDayChange}
        />
        <TextField
          className="TimeSpan"
          disabled={disabled}
          label="Hours"
          type="number"
          value={GetSectionOfTime(totalMins, "hour")}
          onChange={OnHourChange}
        />
        <TextField
          className="TimeSpan"
          disabled={disabled}
          label="Minutes"
          type="number"
          value={GetSectionOfTime(totalMins, "minute")}
          onChange={OnMinuteChange}
        />
      </Box>
    </>
  );
};

const GetSectionOfTime = (totalMinutes, unit) => {
  if (unit === "minute") {
    return totalMinutes % 60;
  }
  if (unit === "hour") {
    const days = GetSectionOfTime(totalMinutes, "day");
    const hours = Math.floor((totalMinutes - days * 24 * 60) / 60);
    return hours;
  }
  if (unit === "day") {
    const days = Math.floor(totalMinutes / (60 * 24));
    return days;
  }
};
const TimeSpanGlobalText = (totalMinutes) => {
  const minutes = GetSectionOfTime(totalMinutes, "minute");
  const hours = GetSectionOfTime(totalMinutes, "hour");
  const days = GetSectionOfTime(totalMinutes, "day");

  return (
    <>
      {days +
        " Day" +
        (days !== 1 ? "s, " : ", ") +
        hours +
        " Hour" +
        (hours !== 1 ? "s, " : ", ") +
        minutes +
        " Minute" +
        (minutes !== 1 ? "s" : "")}
    </>
  );
};
